import styled from '@emotion/styled';

import { colors } from 'src/styles/colors';

import { MediaBP as MQ } from '../../styles/mediaQuery';

export const Container = styled.div`
  padding: 18px 16px;
  ${MQ.MediaSm} {
    padding: 24px 16px;
  }
  ${MQ.MediaMd} {
    padding: 18px 16px;
  }
  ${MQ.MediaLg} {
    padding: 24px 40px;
  }
  ${MQ.MediaXl} {
    padding: 32px 100px;
  }
`;

export const Title = styled.h1`
  color: ${colors.white};
  padding: 16px 0;
  ${MQ.MediaMd} {
    padding: 24px 0;
  }
`;

export const DropDownContainer = styled.div`
  margin-bottom: 36px;
`;
